<template>
  <svg class="svoi-icon" :class="`-size-${size}`" @click="$emit('click')">
    <use :href="`${sprite}#${id}`" />
  </svg>
</template>

<script lang="ts">
import { defineComponent, watchEffect, ref, isVue2 } from 'vue-demi'
import type { PropType } from 'vue-demi'
import { SizesEnum, Sizes } from '@svoi-ui/interfaces/icon'
import { isString } from '@svoi-ui/shared/utils/guards'

export default defineComponent({
  name: 'SvoiIcon',
  props: {
    icon: {
      type: String,
      required: true,
      default: ''
    },
    size: {
      type: String as PropType<Sizes | string>,
      default: SizesEnum.m,
      validator(value: unknown) {
        return (
          isString(value) &&
          [
            SizesEnum.xs.toString(),
            SizesEnum.s.toString(),
            SizesEnum.m.toString(),
            SizesEnum.l.toString(),
            SizesEnum.full.toString()
          ].includes(value)
        )
      }
    }
  },
  emits: ['click'],
  setup(props) {
    const sprite = ref('')
    const id = ref('')

    const requireSprite = (name: string): Promise<string> => {
      return isVue2
        ? Promise.resolve(require(`@svoi-ui/assets/icons/${name}.svg`))
        : import(`@svoi-ui/assets/icons/${name}.svg`).then(module => module.default).catch(() => '')
    }

    watchEffect(() => {
      const chunks = (props.icon as string).split('/')

      if (chunks.length === 2) {
        id.value = chunks[1]
        sprite.value = ''

        requireSprite(chunks[0].toLowerCase()).then(path => {
          sprite.value = path
        })
      } else {
        sprite.value = ''
        id.value = ''
      }
    })

    return { sprite, id }
  }
})
</script>

<style lang="scss" scoped>
@use '@svoi-ui/assets/scss/components/icon.scss';
</style>
